module.exports = __webpack_public_path__ + "static/media/sort-icon.7a23b0c7.svg";